import Adapter from '@ember-data/adapter';
import stockOrdersClient from '@catalog/shared/clients/stock-orders-client';
import { ListTransferOrderLinesRequest } from '@square/dashboard-protos/models/squareup/stockorders/message/transfer_order_lines';
import { hash } from 'rsvp';
export default class TransferOrderLine extends Adapter {
  query(_store, _type, query) {
    // Create and return hash to satisfy Adapter TS definitions
    return hash({
      response: stockOrdersClient.listTransferOrderLines(ListTransferOrderLinesRequest.create(query))
    }).then(({
      response
    }) => {
      const transferOrderLines = response.transferOrderLine.map(line => ({
        ...line,
        transferOrderId: query.transferOrderId
      }));
      transferOrderLines.meta = {
        paginationToken: response.paginationToken
      };
      return transferOrderLines;
    });
  }
}